import {
  AfterViewInit,
  Component,
  ElementRef,
  input,
  signal,
  ViewChild,
} from '@angular/core';
import { Application } from '../../../../shared/models/application';
import { NgOptimizedImage } from '@angular/common';
import { ApplicationIconPipe } from '../../../../shared/pipes/application-icon-pipe';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-application-accordion-card',
  standalone: true,
  imports: [NgOptimizedImage, ApplicationIconPipe, TooltipModule],
  templateUrl: './application-accordion-card.html',
  styleUrl: './application-accordion-card.scss',
})
export class ApplicationAccordionCard implements AfterViewInit {
  public application = input.required<Application>();
  @ViewChild('clamped') clamped!: ElementRef;
  public isOverflow = signal(false);

  ngAfterViewInit() {
    const el = this.clamped.nativeElement;
    this.isOverflow.set(el.scrollHeight > el.clientHeight ? true : false);
  }
}
